<script lang="ts">import { ranksData } from "../data";
import Included from "../icons/included.svelte";
import VipRankRewards from "../icons/rewards.png";
import { getVerbiageKey } from "../utils";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Icon } from "@infinitro/rank-badges";
import { Text } from "@infinitro/text";
$: includeWageringRequirementRow = $stateUi.vip.includeWageringRequirementRow ?? false;
const baseRows = [
	{
		name: Verbiage[getVerbiageKey("rakeback_text")],
		id: "rakeback"
	},
	{
		name: Verbiage[getVerbiageKey("rakeboost_text")],
		id: "rakeboost"
	},
	{
		name: Verbiage[getVerbiageKey("level_up_reward_text")],
		id: "level-up-reward"
	},
	{
		name: Verbiage[getVerbiageKey("daily_bonus_text")],
		id: "daily-bonus"
	},
	{
		name: Verbiage[getVerbiageKey("weekly_bonus_text")],
		id: "weekly-bonus"
	},
	{
		name: Verbiage[getVerbiageKey("monthly_bonus_text")],
		id: "monthly-bonus"
	},
	{
		name: Verbiage[getVerbiageKey("calendar_text")],
		id: "calendar"
	},
	{
		name: Verbiage[getVerbiageKey("anniversary_bonus_text")],
		id: "anniversary-bonus"
	},
	{
		name: Verbiage[getVerbiageKey("dedicated_vip_host_text")],
		id: "dedicated-vip-host"
	},
	{
		name: Verbiage[getVerbiageKey("exclusive_events_text")],
		id: "exclusive-events"
	},
	{
		name: Verbiage[getVerbiageKey("tailored_reload_bonuses_text")],
		id: "tailored-reload-bonuses"
	}
];
let rows = baseRows;
// Some VIP layouts include an extra wagering requirement row.
$: rows = includeWageringRequirementRow ? [{
	name: Verbiage[getVerbiageKey("wagering_required")],
	id: "wagering-required"
}, ...baseRows] : baseRows;
</script>

<div class="vip-rank-rewards">
	<div class="vip-rank-rewards-badge">
		<img src={VipRankRewards} alt={$t(Verbiage.star_alt, 'alts')} />
		<Text type="body" bodySize="small">{$t(Verbiage[getVerbiageKey('rewards_text')])}</Text>
	</div>
	<Text type="title" titleSize="h3" textAlign="center"
		>{$t(Verbiage[getVerbiageKey('vip_rank_rewards')])}</Text
	>
	<div class="vip-rank-rewards-container">
		<InfoCard>
			<div class="table-container">
				<div class="ranks-reward-table">
					<div class="table-header">
						{#each ranksData as rank, tierIndex}
							<div class="header-cell">
								<div class="badge-container">
									<Icon rank={tierIndex + 1} level={5} size={16} />
								</div>
								{$t(Verbiage[rank.name.toLowerCase()])}
							</div>
						{/each}
					</div>
					<div class="table-body">
						<div class="table-side">
							{#each rows as row}
								<div class="side-cell">{$t(row.name)}</div>
							{/each}
						</div>
						<div class="table-content">
							{#each rows as row}
								{#if row.id === 'wagering-required' && includeWageringRequirementRow}
									<div class="content-row">
										{#each ranksData as rank}
											<div class="content-cell">
												<div class="content-cell">{rank.amount}</div>
											</div>
										{/each}
									</div>
								{:else}
									<div class="content-row">
										{#each ranksData as rank}
											<div class="content-cell">
												{#if rank.rewards.includes(row.id)}
													<Included />
												{/if}
											</div>
										{/each}
									</div>
								{/if}
							{/each}
						</div>
					</div>
				</div>
			</div>
		</InfoCard>
	</div>
</div>

<style>
	.vip-rank-rewards {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.75rem;
}

	.vip-rank-rewards-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.25rem;
		border-radius: 9999px;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		background: var(--gradient-main);
}

	.vip-rank-rewards-container {
		margin-top: 1rem;
		display: flex;
		width: 100%;
		flex-direction: column;
}

	.table-container {
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: thin;
		scrollbar-color: var(--color-neutral-900) var(--color-background-900);
}

	.table-container::-webkit-scrollbar {
		height: 0.5rem;
		width: 0.5rem;
		background-color: transparent;
		display: block;
}

	.table-container::-webkit-scrollbar-track {
		background-color: var(--color-background-900);
}

	.table-container::-webkit-scrollbar-thumb {
		border-radius: 0.5rem;
		background-color: var(--color-neutral-900);
		--tw-shadow-color: var(--shadow-neutral);
		--tw-shadow: var(--tw-shadow-colored);
}

	@media (max-width: 768px) {
		.table-container {
			overflow-x: scroll;
			-ms-overflow-style: -ms-autohiding-scrollbar;
		}

		.table-container::-webkit-scrollbar {
			-webkit-appearance: none;
			height: 4px;
		}
	}

	.ranks-reward-table {
		width: 100%;
		min-width: 1200px;
		border-radius: 0.5rem;
}
	@media (min-width: 1024px) {
		.ranks-reward-table {
				min-width: 0px;
		}
	}

	.table-header {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
		background-color: var(--color-background-500);
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		padding-left: 105px;
		padding-right: 5px;
		z-index: 5;
		position: relative;
}

	.header-cell {
		display: flex;
		width: 9%;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0.125rem;
		font-size: 0.65rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}
	@media (min-width: 640px) {
		.header-cell {
				font-size: 0.5rem;
		}
	}

	.badge-container {
		display: flex;
		height: 1.5rem;
		width: 1rem;
		align-items: center;
		justify-content: center;
}

	.table-body {
		display: flex;
}

	.table-side {
		display: flex;
		width: 100px;
		flex-direction: column;
		gap: 0.5rem;
		border-top-left-radius: 0.5rem;
		border-bottom-left-radius: 0.5rem;
		background-color: var(--color-background-500);
		padding-bottom: 1rem;
		position: absolute;
		z-index: 10;
		transform: translateX(-1px);
		top: 1rem;
		padding-top: 2.5rem;
}

	.side-cell {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: flex-start;
		padding-left: 0.5rem;
		font-size: 0.65rem;
		font-weight: 600;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		opacity: 0.5;
		font-family: var(--font-main);
}

	.side-cell:last-child {
		height: 20px;
}

	.table-content {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 0.5rem;
}

	.content-row {
		display: flex;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		background-color: var(--color-background-500);
		padding-left: 105px;
}

	.content-row:nth-child(odd) {
		background-color: transparent;
}

	.content-cell {
		display: flex;
		width: 9.5%;
		align-items: center;
		justify-content: center;
		padding: 0.5rem;
		padding-right: 1rem;
		text-align: left;
		font-size: 0.75rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
}
</style>
